"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_MONTHS = void 0;
var MAX_MONTHS = exports.MAX_MONTHS = 9;